import React from 'react'
import EduOutreach from '../Images/Classroom-Programming.jpg'
import EduOutreach2 from '../Images/Classroom-Programming-2.jpg'
import EduOutreach3 from '../Images/Classroom-Programming-3.jpg'


export default function EducationalOutreachPrograms() {
  return (
    <div className='bg-white p-20 '>
      <div className='pb-2'><div><h1 className='text-2xl text-[#F27920]'>Classroom Programming</h1></div></div>
      <div><div className="pb-5">The National Save The Sea Turtle Foundation works closely with the Inwater Research Group (IRG) to promote quality educational programming. The Foundation recently donated $31,350 to IRG to continue their international education initiative for K-12 students.</div></div>

      <div><div>The initiative is entirely free to teachers and includes tailor-made lesson plans, in-class outreach presentations, and new “traveling trunks” containing all the education material teachers would need to carry out four conservation-based lesson plans. Just this past year alone, the partnership has been able to reach over 20,000 students with these programs. </div></div>

      <div className='lg:flex gap-4'>
        <div className='lg:w-1/2 my-5'><img className='rounded-2xl' src={EduOutreach} alt='' title='' /></div>
        <div className='lg:w-1/2 my-5'><img className='rounded-2xl' src={EduOutreach2} alt='' title='' /></div>
        <div className='lg:w-1/2 my-5'><img className='rounded-2xl' src={EduOutreach3} alt='' title='' /></div>
      </div>

      <div><div className="pb-5"><h1 className='text-2xl text-[#F27920]'>North Beaches Art Walk</h1></div></div>
      <div><div className="pb-5">The National Save The Sea Turtle Foundation brings awareness about sea turtle conservation to the visitors of the North Beaches Art Walk in the Atlantic/Neptune Beach areas of Jacksonville Florida. The goal is to meet, educate, and encourage people to help protect sea turtles. On a typical art walk night (third Thursday of every month), the local community and visitors pack the streets of Atlantic/Neptune Beach Town Center area to enjoy this fun event.</div></div>



    </div>


  )
}
